import { Box, Typography, useTheme } from '@mui/material';
import { FC, useState } from 'react';

import { ALLOW_FOOTER_LINKS_PREFETCH } from '@/constants/prefetch';
import { FormattedMessage } from 'react-intl';
import Link from 'next/link';
import { pxToRem } from '@/theme/typography';

interface footerProps {
  icon: (color: string) => JSX.Element;
  text: string;
  path: string;
}

export const FooterLink: FC<footerProps> = ({ icon: Icon, text, path }) => {
  const theme = useTheme();
  const [linkColor, setLinkColor] = useState<string>(theme.palette.common.white);

  return (
    <Box
      component='li'
      onMouseOver={() => setLinkColor(theme.palette.grey[10])}
      onMouseLeave={() => setLinkColor(theme.palette.common.white)}
      onMouseDown={() => setLinkColor(theme.palette.grey[20])}
      sx={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: '16px',
        '&:hover': {
          cursor: 'pointer',
        },
      }}
    >
      <Link
        href={{ pathname: `/${path}` }}
        legacyBehavior
        passHref
        prefetch={ALLOW_FOOTER_LINKS_PREFETCH}
      >
        <Box
          component='a'
          sx={{
            display: 'flex',
            textDecoration: 'none',
            alignItems: 'center',
          }}
        >
          {Icon(linkColor)}
          <Typography
            variant='caption'
            component='div'
            sx={{
              color: linkColor,
              marginInlineStart: '10px',
              fontWeight: '700',
              fontSize: pxToRem(16),
            }}
          >
            <FormattedMessage id={text} />
          </Typography>
        </Box>
      </Link>
    </Box>
  );
};

export default FooterLink;
